import { getToken } from '@/helpers/jwt'

export const state = () => ({
  token: getToken(),
  rememberMe: true,
})
